import {useSessionStorage} from '../hooks/useSessionStorage'
import { useNavigate } from "react-router-dom";
// import Button from '@mui/material/Button';
import Container from '@mui/material/Container';

// import ReCaptchaProvider from '../layout/ReCaptchaProvider';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useEffect } from 'react';

export default function LoginPage()
{
    const [token, setToken] = useSessionStorage('FormulatorToken','');
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const buttonClick=()=>{
        executeRecaptcha('demo').then((result)=>{
            fetch(`${process.env.REACT_APP_API_BASEURL}Login`, {
              method: 'POST', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors', // no-cors, *cors, same-origin
              cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
              credentials: 'same-origin', // include, *same-origin, omit
              headers: {
                  'Content-Type': 'application/json'
                  // 'Content-Type': 'application/x-www-form-urlencoded',
              },
              redirect: 'follow', // manual, *follow, error
              referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
              body: JSON.stringify({'RecaptchaResponse':result})
              })
              .then(res => res.json())
              .then(data => {
                  if(data?.key)
                  {
                    setToken(data.key);
                    navigate('/demo');
                  }
                  else
                  {
                    alert('Error retrieving logon key');
                  }
              })
              .catch(error=>{
                  alert(error);
              });
        });
    }

    useEffect(()=>{
        if(executeRecaptcha !== undefined)
            buttonClick();
    },[executeRecaptcha]);
    return <>
    <Container maxWidth="md" sx={{textAlign:'center'}}>
    <h1 sx={{marginTop:5}}>Conducting a ReCaptcha Check...</h1>
    </Container>
    </>
}